// extracted by mini-css-extract-plugin
export default {"main":"MainPage_main__4vpBR","welcome":"MainPage_welcome__WFu1w","videoRow":"MainPage_videoRow__JGE-Q","options":"MainPage_options__psatR","colNews":"MainPage_colNews__nDPb0"};